import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLms } from '../../app/features/userSlice';

const KajabiCallback = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { search } = useLocation();

	useEffect(() => {
		const params = new URLSearchParams(search);
		const code = params.get('code');

		if (!code) {
			navigate('/', { replace: true });
			return;
		}

		dispatch(setLms('kajabi'));
		navigate(`/?${params.toString()}`, { replace: true });
	}, [search, navigate, dispatch]);

	return null;
};

export default KajabiCallback;
